import { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { Const } from "../constants/Constants";

const AuthenticatedGuard: FC = ({ children }) => {
    // JWTがNULLでないとき、認証OKとする
    const isAuthenticated = sessionStorage.getItem(Const.LOCAL_STORAGE_VALUE.JWT) !== null;

// TODO:開発時、認証制御を停止
//return <>{children}</>
    // 認証OKのときは、該当画面へ遷移、NGのときはログイン画面に遷移
    return isAuthenticated ? <>{children}</> : <Redirect to={{
        pathname: '/login',
    }} />;
};

export default AuthenticatedGuard;
